export const side_nav = [
  {
    id: 1,
    title: 'about',
    to: '/#about',
  },
  {
    id: 2,
    title: 'network_of_pharmacies',
    to: '/drugstores',
  },
  {
    id: 3,
    title: 'promotions',
    to: '/promotions',
  },
];
